import { IoIosArrowRoundUp } from "react-icons/io";
import { ReactNode} from "react";
import { cn } from "@/lib/utils";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

export const StaticDashboard = ({
    title,
    subTitle,
    logo,
    percentage,
  }: {
    day: string;
    title: string;
    subTitle: number;
    logo: ReactNode;
    percentage: string;
  }) => {
    const { locale } = useLocale();
    const { t } = useTranslate(locale);
    return (
      
      <div
        className={cn(
          "bg-white  cursor-pointer px-2 py-4 flex flex-col gap-3 rounded-xl",
          { "bg-stone-100": false }
        )}
      >
        <div className="flex items-start  justify-between">
          <div className="pr-4 flex items-center gap-4">
            <div className="h-12 w-2 bg-[#644980] rounded-full">.</div>
            <div className="flex flex-col gap-2">
              <div className="text-xl text-zinc-500 font-bold">{title}</div>
              <div className="text-2xl font-semibold">{subTitle}</div>
            </div>
          </div>
          <div className="bg-purple-100 p-[6px] w-fit rounded-xl">
            {/* <TbFileInvoice /> */}
            <div className="text-[#644980] text-4xl">{logo}</div>
          </div>
        </div>
        <div className="flex gap-2 items-center">
          <div className="flex flex-row-reverse items-center">
            {percentage} <IoIosArrowRoundUp className="text-xl text-green-500" />
          </div>
          <div className="text-zinc-500 font-semibold">{t("time.lastWeek")}</div>
        </div>
      </div>
    );
  };
  